// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2B4Ch","savePackageButton":"ClientWallet_savePackageButton__2hVC9"};